module.exports = "<div class=\"viewstack-header\">\n  <div class=\"viewstack-left\">\n    <span class=\"viewstack-backicon\"></span>\n    <span class=\"viewstack-backtext\"></span>\n  </div>\n  <div class=\"viewstack-title\">\n  </div>\n  <div class=\"viewstack-action\">\n  </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./lib/header.html
 ** module id = 22
 ** module chunks = 0
 **/